import { Billboard } from '@react-three/drei'
import { suspend } from 'suspend-react'
import * as THREE from 'three'

import { createLazy, getValueOfCssVariable } from '@/lib/utils'
import AsyncBoundary from '@components/AsyncBoundary.tsx'
import { loadTexture, useBobbing } from '@components/storeMap/floor/3d/util'
import { useCashRegisters } from '@state/cashRegister'

const PIN_SIZE = 0.8

import cashRegisterIcon from '../../cashRegister.svg'

const getColorsForCashRegister = createLazy(() => {
  return {
    cashRegisterColor: getValueOfCssVariable('--color-cash-register'),
  }
})

const cashRegisterHeight = 1
const textureSize = 100

function CashRegister() {
  const bobbingRef = useBobbing()
  const { data: cashRegisters } = useCashRegisters()
  const { cashRegisterColor } = getColorsForCashRegister()

  const texture = suspend(() => loadTexture({ imageUrl: cashRegisterIcon, size: textureSize }), [cashRegisterIcon, textureSize])

  if (!cashRegisters) return null

  return (
    <>
      {cashRegisters.map((cashRegister, i) => (
        <group
          key={i}
          position={[cashRegister.x, cashRegisterHeight / 2, cashRegister.y]}
          rotation={[0, cashRegister.rotation, 0]}
        >
          <mesh castShadow={true} receiveShadow={true}>
            <boxGeometry args={[1.5, cashRegisterHeight, 3.5]} />
            <meshStandardMaterial color={cashRegisterColor} />
          </mesh>

          <Billboard follow={true} lockX={false} lockY={false} lockZ={false}>
            <mesh
              position={[0, 1.5, 0]}
              ref={bobbingRef}
            >
              <planeGeometry args={[PIN_SIZE, PIN_SIZE]} />
              <meshBasicMaterial map={texture} transparent side={THREE.DoubleSide} />
            </mesh>
          </Billboard>

          {/* shadow thrower */}
          <mesh
            position={[0, PIN_SIZE, 0]}
            castShadow
          >
            <boxGeometry args={[0.6, 0.6, 0.6]} />
            <meshBasicMaterial colorWrite={false} depthWrite={false} />
          </mesh>
        </group>
      ))}
    </>
  )
}

function WrappedCashRegister() {
  return (
    <AsyncBoundary>
      <CashRegister />
    </AsyncBoundary>
  )
}

export default WrappedCashRegister